<template>
    <div class="login-page">
        <div class="login-box">
        <div class="shop-title">
            <img src="../../assets/login/thumb.png" alt="">
        </div>
        <div class="login-content">
            <div class="element-div">
                <div class="login-title">苏小融后台管理系统</div>
                <Form ref="loginForm" :model="loginForm" :rules="ruleCustom" :label-width="0" class="login-formstyle">

                    <FormItem  class="itemss" prop="name">
                        <div class="login-names">用户名： </div>
                        <input type="text" placeholder="填写用户名" v-model="loginForm.name" @keyup.enter="loginSubmit"/>
                        <!-- <Input type="text"  placeholder="填写用户名" v-model="loginForm.name" @keyup.enter.native="loginSubmit"></Input> -->
                    </FormItem>
                    <FormItem class="itemss" prop="password">
                        <div class="login-names" >密码：</div>
                         <input type="password" placeholder="填写密码" v-model="loginForm.password" @keyup.enter="loginSubmit"/>
                        <!-- <Input type="password" placeholder="填写密码" v-model="loginForm.password" @keyup.enter.native="loginSubmit"></Input> -->
                    </FormItem>
                    <FormItem class="itemss" prop="verify_code">
                        <div class="login-names">验证码：</div>
                        <div style="display:flex;align-items: center">
                             <input type="text" v-model="loginForm.verify_code" @keyup.enter="loginSubmit"/>
                            <!-- <Input type="text" v-model="loginForm.verify_code" @keyup.enter.native="loginSubmit" ></Input> -->
                            <img @click="changeCaptcha" :src="captchaurl" class="login-imgs"/>
                        </div>
                    </FormItem>
                    <FormItem  class="login-btn">
                        <Button :disabled="disabled"  @click="loginSub('loginForm')" class="login-btn-sub">登录</Button>
                    </FormItem>
                </Form>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import isValid from '../../common/isValid.js';
import common from '@/common/common.js';
    export default {
        data() {
            return {
                captchaurl:'',
                loginForm: {
                    password: '',
                    name: '',
                    verify_code: '',
                    verify_key:''
                },
                ruleCustom: {

                    name: [
                        { required: true, message: '用户名必须填写', trigger: 'blur' },
                        { min: 1, max: 30, message: '用户名长度1 - 30', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '密码必须填写', trigger: 'blur' },
                        { min: 6, max: 15, message: '密码长度6 - 15', trigger: 'blur' }
                    ],
                    verify_code: [
                        { required: true, message: '验证码必须填写', trigger: 'blur' }
                    ]
                },
                disabled: false
            }
        },
        methods: {
            loginSub(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true
                        isValid.getNewToken(this.config.urlArray.getToken, this.loginForm, 1, ()=>{
                           this.disabled = false;
                           this.changeCaptcha(); //刷新图形验证码
                        });
                    }
                })
            },
            loginSubmit(event) { // enter快捷键
                event = event || window.event;
                if (event.keyCode === 13) {
                    this.loginSub('loginForm');
                }
            },
            changeCaptcha (){
                this.getCaptcha();
            },
            getCaptcha () {
              this.axios.get(this.config.urlArray.captcha,{}).then((res)=>{
                  this.captchaurl = res.data.data.img;
                  this.loginForm.verify_key = res.data.data.key;
              })
            },
            toRetievePwd() {
                this.$router.push({
                    path: '/retrievePwd'
                })
            }
        },
        mounted:function (){
          this.getCaptcha();
        }
    }
</script>
<style>
.pswp__bg, .pswp__scroll-wrap{
    z-index: -1;
}
</style>
<style  lang='scss' scoped>
#app {
    width: 100%;
    height: 100%;
}
.ident-pos{
    margin-top: 8px;
}
.type-css{
    width: 152px;margin-left:15px;float: right;
}
.login-page {
    width: 100%;
    height: 100vh;
    position: relative;
}
.login-content {
    height: 100%;
    background: #fff;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    justify-content: center;
    .ivu-input{
        border: none !important;
    }
}
.login-box{
    position: absolute;
    width: 1000px;
    height: 550px;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    overflow: hidden;
}
.shop-title{
    flex: 1;
    background: #CDFFF5;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 390px;
    }
}
.login-title {
    width: 345px;
    line-height: 50px;
    text-align: center;
    font-size: 24px;
    margin: 0 auto;
    color: #02ACA2;
    margin-top: 20%;
    margin-bottom: 30px;
}

.login-btn {
    width: 100%;
    height: 40px;
    margin-top: 10px;
}
.login-btn-sub {
    width: 100%;
    background: #02ACA2;
    color: #fff;
    height: 40px;
}
.login-names {
    width: 110px;
    padding-left: 10px;
}
.login-imgs {
    margin-left: 10px;
    height: 38px;
}
.login-support {
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-top: 30px;
}
.ivu-form-item {
    margin-bottom: 30px !important;
}
/*  -------------------------------------------------  */
.forget-pwd>span {
    cursor: pointer;
}
.login-page{
    background:#F5F5F7 url("../../assets/login/bc_img.png")  no-repeat;
    background-size:100% 100%;
    background-position: center;
}
.shop-title1{
    font-size:29px;
    color:black;
    margin-bottom:35px;

}
.shop-title2{
    width:368px;
    line-height:30px;
    font-size:16px;
    color:#A7A7A7;
}
.itemss{
    width:100%;
    display:flex;
    border:1px solid #DDDDDD;
    flex-wrap:nowrap;
    height: 40px;
    align-items: center;
    input{
        border: none;
        width: 100%;
        outline: none;
    }
}
.ivu-form-item-error .ivu-input{
    height: 38px;
    border:none !important;
}
>>>.ivu-input{
    height: 38px !important;
    border:none !important;
}
</style>
<style>
.login-page .ivu-form-item-content{
    margin-left: 0 !important;
}
.login-page .ivu-form-item-content{
    display: flex;
    width:100%;
    justify-items:center;
}
.forget-pwd {
    text-align: right;
    padding: 15px 0;
    font-size: 14px;
    /* cursor: pointer; */
    color: #666666;
    width:345px;
    height:50px;
}
/* ----------------------- */

</style>


